import React, { FC } from 'react'
import { useParams } from 'react-router-dom'

import { ArticleDefault, SectionDefault } from './customComponents'

interface Props {
  handleChangeView: (permalink: string, page: string) => void
}
const Section: FC<Props> = (props: Props) => {
  const params = useParams()
  return (
    <>
      {(params.type === 'section' || params.type === 'sezione') && (
        <SectionDefault
          changeView={props.handleChangeView}
          isExternal
          searchKey={params.id}
        />
      )}
      {(params.type === 'article' || params.type === 'articolo') && (
        <ArticleDefault
          changeView={(permalink, page) =>
            props.handleChangeView(permalink, page)
          }
          searchKey={params.id}
          isExternal={true}
          embedded={false}
          isInternal={false}
          parentsArticle={[]}
        />
      )}
    </>
  )
}
export default Section
